<template>
  <div class="bank-statement-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="vertical-align: sub"
          ><i class="el-icon-date"></i> Statement</span
        >
      </div>
      <div>
        <div class="search-area">
          <el-date-picker
            v-model="dateSearch"
            type="month"
            format="MM-yyyy"
            style="width: 120px"
          >
          </el-date-picker>
          <el-button
            slot="append"
            type="primary"
            icon="el-icon-search"
            @click="getTransactionData()"
            >Search</el-button
          >
          <el-button
            icon="el-icon-download"
            type="success"
            @click="ExcelReport()"
            >Excel</el-button
          >
          <el-button icon="el-icon-download" type="success" @click="PDFReport()"
            >PDF</el-button
          >
        </div>

        <el-table
          v-loading="loading"
          :data="tableData"
          row-key="uid"
          border
          lazy
          :load="loadDetailTransaction"
          :tree-props="{ children: 'children', hasChildren: 'isReceive' }"
        >
          <el-table-column
            sortable
            prop="transactionDate"
            label="Date"
            width="160"
            header-align="center"
            align="right"
          >
          </el-table-column>
          <el-table-column
            sortable
            prop="relateDetail3"
            label="Member Code"
            width="130"
            header-align="center"
            align="center"
            v-if="apiMode === 'project'"
          >
          </el-table-column>
          <el-table-column
            prop="description"
            label="Description"
            width="200"
            header-align="center"
            align="left"
          >
          </el-table-column>
          <el-table-column
            prop="relateDetail1"
            label="Detail 1"
            header-align="center"
            align="left"
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="relateDetail2"
            label="Detail 2"
            header-align="center"
            align="left"
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="status"
            label="Status"
            header-align="center"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              <el-tag
                v-if="
                  scope.row.status &&
                    scope.row.status.toLowerCase() == 'accepted'
                "
                size="mini"
                type="success"
                >{{ scope.row.status.toUpperCase() }}</el-tag
              >
              <el-tag
                v-if="
                  scope.row.status && scope.row.status.toLowerCase() == 'review'
                "
                size="mini"
                >{{ scope.row.status.toUpperCase() }}</el-tag
              >
              <el-tag
                v-if="
                  scope.row.status &&
                    scope.row.status.toLowerCase() == 'internal'
                "
                type="warning"
                size="mini"
                >{{ scope.row.status.toUpperCase() }}</el-tag
              >
              <el-tag
                v-if="
                  scope.row.status && scope.row.status.toLowerCase() == 'na'
                "
                type="info"
                size="mini"
                >N/A</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="debit"
            label="Debit"
            header-align="center"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="credit"
            label="Credit"
            header-align="center"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="balance"
            label="Balance"
            header-align="center"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            sortable
            prop="currency"
            label="Currency"
            header-align="center"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              {{ scope.row.currency && scope.row.currency.toUpperCase() }}
            </template>
          </el-table-column>
          <el-table-column
            prop="reference"
            label="Reference"
            header-align="center"
            align="center"
            width="300"
          >
          </el-table-column>
          <el-table-column
            sortable
            prop="hasreturn"
            label="Return Fund"
            header-align="center"
            align="center"
            width="120"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.hasreturn"
                icon="el-icon-refresh-left"
                style="padding:0"
                size="mini"
                type="text text-danger"
                @click="returnFund(scope.row.transaction_id)"
                >Return Fund</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="uid"
            label="Detail"
            header-align="center"
            align="center"
            width="70"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                icon="el-icon-view"
                style="padding:0"
                size="mini"
                type="text"
                @click="viewDetail(scope.row.uid)"
                >View</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          class="pagination-statement"
          @size-change="setPageSize"
          @current-change="setPage"
          :current-page.sync="page"
          :page-sizes="[10, 20, 50, 100, 200]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalItem"
        >
        </el-pagination>
      </div>
    </el-card>

    <el-dialog
      title="Statement detail"
      :visible.sync="dialogVisible"
      :width="device === 'mobile' ? '95%' : '70%'"
      top="5vh"
    >
      <el-row :gutter="10" v-if="Object.keys(detail).length > 0">
        <el-col :xs="24" :sm="24" :md="24" :lg="12">
          <el-form
            class="bank-info"
            label-width="150px"
            size="small"
            :label-position="device === 'mobile' ? 'left' : 'right'"
          >
            <el-form-item label="UID">
              {{ detail.uid }}
            </el-form-item>
            <el-form-item label="Date">
              {{ detail.transactionDate }}
            </el-form-item>
            <el-form-item label="Description">
              {{ detail.description }}
            </el-form-item>
            <el-form-item label="Detail 1">
              {{ detail.relateDetail1 }}
            </el-form-item>
            <el-form-item label="Detail 2">
              {{ detail.relateDetail2 }}
            </el-form-item>
            <el-form-item label="Debit">
              {{ detail.debit }}
            </el-form-item>
            <el-form-item label="Credit">
              {{ detail.credit }}
            </el-form-item>
            <el-form-item label="Balance">
              {{ detail.balance }}
            </el-form-item>
            <el-form-item label="Currency">
              {{ detail.currency.toUpperCase() }}
            </el-form-item>
            <el-form-item label="Reference">
              {{ detail.reference }}
            </el-form-item>
            <el-form-item label="Transaction ID">
              {{ detail.transactionId }}
            </el-form-item>
            <el-form-item label="ARN number">
              {{ detail.acquirer_reference_number }}
            </el-form-item>
            <el-form-item label="Status">
              <el-tag
                v-if="
                  detail.status && detail.status.toLowerCase() == 'accepted'
                "
                type="success"
                >{{ detail.status.toUpperCase() }}</el-tag
              >
              <el-tag
                v-if="detail.status && detail.status.toLowerCase() == 'review'"
                >{{ detail.status.toUpperCase() }}</el-tag
              >
              <el-tag
                v-if="
                  detail.status && detail.status.toLowerCase() == 'internal'
                "
                type="warning"
                >{{ detail.status.toUpperCase() }}</el-tag
              >
              <el-tag
                v-if="detail.status && detail.status.toLowerCase() == 'rejected'"
                type="danger"
                >{{ detail.status.toUpperCase() }}</el-tag
              >
              <el-tag
                v-if="detail.status && detail.status.toLowerCase() == 'na'"
                type="info"
                >N/A</el-tag
              >
            </el-form-item>
          </el-form>
        </el-col>

        <el-col
          :xs="24"
          :sm="24"
          :md="24"
          :lg="12"
          v-if="detail.transaction_printout"
        >
          <h4>Transaction Detail</h4>
          <pre v-html="detailRender(detail.transaction_printout)"></pre>
          <div v-if="detail.vender_status" class="vender-status">
            <h4>Vendor Status</h4>
            <div v-if="detail.vender_status.error" class="vender-status-error">
              {{ detail.vender_status.error }}
            </div>
            <template v-else>
              <div class="vender-status-main">
                <el-tag
                  size="medium"
                  effect="dark"
                  :type="venderStatusType(detail.vender_status.state)"
                  >{{ detail.vender_status.status || detail.vender_status.state }}</el-tag
                >
              </div>
              <pre v-html="detailRender(venderStatusDetail(detail.vender_status))"></pre>
            </template>
          </div>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Close</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="`Return Fund`"
      :visible.sync="dialogVisibleReturnFund"
      :width="device === 'mobile' ? '95%' : '50%'"
      top="5vh"
    >
      <el-row
        :gutter="10"
        v-if="
          Object.keys(returnFundData).length > 0 && getReturnFundMsgErr === ''
        "
      >
        <el-col :xs="24" :sm="24" :md="24" :lg="24">
          <el-form
            class="bank-info"
            label-width="150px"
            :label-position="device === 'mobile' ? 'left' : 'right'"
            ref="returnFundForm"
            :model="returnFundData"
            :rules="ruleReturnFund"
          >
            <el-form-item label="Name">
              <el-input v-model="returnFundData.senderName" readonly></el-input>
            </el-form-item>
            <el-form-item
              :label="
                returnFundData.currency === 'GBP' ? 'Account number' : 'IBAN'
              "
              prop="accountNumberIban"
            >
              <el-input
                v-model="returnFundData.accountNumberIban"
                :readonly="vender != 'ifx'"
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="returnFundData.currency === 'GBP' ? 'Sortcode' : 'BIC'"
              prop="sortcodeSwift"
            >
              <el-input
                v-model="returnFundData.sortcodeSwift"
                :readonly="vender != 'ifx'"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="Swiftbic"
              v-if="vender === 'ifx' && returnFundData.currency === 'GBP'"
              prop="swiftbic"
            >
              <el-input v-model="returnFundData.swiftbic"></el-input>
            </el-form-item>
            <el-form-item
              label="Countrycode"
              v-if="vender === 'ifx' && returnFundData.currency === 'EUR'"
              prop="countrycode"
            >
              <el-select
                style="width:100%"
                v-model="returnFundData.countrycode"
                filterable
                placeholder="Select"
              >
                <el-option
                  v-for="(item, index) in country"
                  :key="index"
                  :label="
                    `${getFlagEmoji(item.country_code)}  ${item.country_name}`
                  "
                  :value="item.country_code"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Amount">
              <el-input v-model="returnFundData.amount" readonly></el-input>
            </el-form-item>
            <el-form-item label="Currency">
              <el-input v-model="returnFundData.currency" readonly></el-input>
            </el-form-item>
            <el-form-item label="Remark">
              <el-input
                v-model="returnFundData.remark"
                type="textarea"
                :rows="2"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <h2 class="text-center text-danger">
        {{ getReturnFundMsgErr || "Please confirm to refund back to sender" }}
      </h2>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleReturnFund = false">Close</el-button>
        <el-button
          type="primary"
          @click="submitReturnFund()"
          :loading="submiting"
          :disabled="getReturnFundMsgErr === '' ? false : true"
          >Confirm</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getStatement,
  getExcel,
  getDetail,
  getPDF,
  getSenderInfo,
} from "@/api/statements";
import { getReturnFund, postReturnFund } from "@/api/transaction";
import { currentDateTime, firstOfMonth, lastOfMonth, uuid } from "@/utils";
import { getUtility } from "@/api/customer";
export default {
  props: {
    bankholderID: String,
    apiMode: String,
    vender: String,
  },
  computed: {
    device() {
      return this.$store.state.app.device;
    },
  },
  data() {
    return {
      dateSearch: new Date(),
      bankholder_id: this.bankholderID,
      start_date: "",
      end_date: "",
      tableData: [],
      loading: false,
      detail: {},
      dialogVisible: false,
      dialogVisibleReturnFund: false,
      returnFundData: {
        senderName: "",
        accountNumberIban: "",
        sortcodeSwift: "",
        amount: 0,
        currency: "",
        remark: "",
        countrycode: "",
        swiftbic: "",
      },
      ruleReturnFund: {
        accountNumberIban: [
          {
            required: true,
            message: "Please input Account number / IBAN",
            trigger: "blur",
          },
        ],
        sortcodeSwift: [
          {
            required: true,
            message: "Please input Sortcode / BIC",
            trigger: "blur",
          },
        ],
        swiftbic: [
          {
            required: true,
            message: "Please input Swiftbic",
            trigger: "blur",
          },
        ],
        countrycode: [
          {
            required: true,
            message: "Please input Country code",
            trigger: "blur",
          },
        ],
      },
      submiting: false,
      getReturnFundMsgErr: "",
      postTransactionID: "",
      pageSize: 20,
      page: 1,
      totalItem: 0,
      country: [],
    };
  },
  methods: {
    getUtility() {
      getUtility().then(({ result, data }) => {
        if (result) {
          this.country = data.country.filter(
            (country) => country.country_code != ""
          );
        }
      });
    },
    getFlagEmoji(countryCode) {
      if (!countryCode) return "";
      // แปลงเป็น Emoji ธง
      return countryCode
        .toUpperCase()
        .replace(/./g, (char) =>
          String.fromCodePoint(char.charCodeAt(0) + 127397)
        );
    },
    getTransactionData() {
      Array.prototype.random = function() {
        return this[Math.floor(Math.random() * this.length)];
      };
      this.loading = true;
      this.start_date = firstOfMonth(this.dateSearch);
      this.end_date = lastOfMonth(this.dateSearch);
      let query = {
        page: this.page,
        items_per_page: this.pageSize,
        order: "desc",
      };
      getStatement(
        this.bankholder_id,
        this.start_date,
        this.end_date,
        query
      ).then(({ result, data }) => {
        this.loading = false;
        if (result) {
          this.totalItem = data.totalItem;
          this.tableData = data.records;
          this.tableData.forEach((item) => {
            item.hasreturn = this.checkReturnfund(item);
          });
        }
      });
    },
    setPage(val) {
      this.page = val;
      this.getTransactionData();
    },
    setPageSize(val) {
      this.pageSize = val;
      this.getTransactionData();
    },
    viewDetail(uid) {
      const loading = this.$notifyloading("Loading data...");
      getDetail(uid).then(({ result, data }) => {
        loading.close();
        if (result) {
          this.detail = data;

          this.dialogVisible = true;
        }
      });
    },
    mapDataSenderInfo(data) {
      let senderInfo = {
        uid: uuid(),
        description: `Name: ${data.name}`,
        relateDetail1: "",
        relateDetail2: "",
      };
      if (data.type === "SCAN") {
        senderInfo.relateDetail1 = `Account number: ${data.accountNumber}`;
        senderInfo.relateDetail2 = `Sortcode: ${data.sortcode}`;
      } else {
        senderInfo.relateDetail1 = `IBAN: ${data.iban}`;
        senderInfo.relateDetail2 = `BIC: ${data.bic}`;
      }
      return [senderInfo];
    },
    loadDetailTransaction(tree, treeNode, resolve) {
      let uid = tree.uid;
      getSenderInfo(uid).then(({ result, data }) => {
        if (result && data) {
          let children = this.mapDataSenderInfo(data);
          resolve(children);
        } else {
          resolve([]);
        }
      });
    },
    venderStatusType(state) {
      if (state === "settled") return "success";
      if (state === "rejected") return "danger";
      return "warning";
    },
    venderStatusDetail(data) {
      const output = {};
      Object.keys(data).forEach((key) => {
        if (key !== "status" && data[key] !== undefined) {
          output[key] = data[key];
        }
      });
      return output;
    },
    detailRender(data) {
      let detail = [];
      Object.keys(data).forEach((key) => {
        let element = data[key];
        if (typeof element === "object") {
          let subdetail = [];

          Object.keys(element).forEach((keysub) => {
            let elementsub = element[keysub];
            subdetail.push(
              `<b>${key}_${keysub}</b>: <code>${elementsub}</code>`
            );
          });

          detail.push(`${subdetail.join("\n")}`);
        } else {
          detail.push(`<b>${key}</b>: <code>${element}</code>`);
        }
      });

      return detail.join("\n");
    },
    submitReturnFund() {
      this.$refs.returnFundForm.validate((valid) => {
        if (valid) {
          this.submiting = true;
          postReturnFund(this.postTransactionID, this.returnFundData).then(
            ({ result }) => {
              this.submiting = false;
              if (result) {
                this.dialogVisibleReturnFund = false;
                this.getTransactionData();
              }
            }
          );
        }
      });
    },
    returnFund(transaction_id) {
      const loading = this.$notifyloading("Loading data...");
      getReturnFund(transaction_id).then(({ result, data, message }) => {
        loading.close();
        if (result) {
          if (data) {
            this.returnFundData.senderName = data.senderName;
            this.returnFundData.accountNumberIban = data.accountNumberIban;
            this.returnFundData.sortcodeSwift = data.sortcodeSwift;
            this.returnFundData.amount = data.amount;
            this.returnFundData.currency = data.currency;
            this.returnFundData.remark = data.remark;
            this.returnFundData.countrycode = data.countrycode;
            this.returnFundData.swiftbic = data.swiftbic;
          }
          this.dialogVisibleReturnFund = true;
          this.getReturnFundMsgErr = message != "Success" ? message : "";
          this.postTransactionID = transaction_id;
        }
      });
    },
    checkReturnfund(row) {
      let type = ["Bank Transfer Load"];
      let description = ["Receive FasterPayments", "Receive EU SEPA Step2"];
      if (type.includes(row.type)) {
        if (description.includes(row.description)) {
          return true;
        }
      }

      return false;
    },
    ExcelReport() {
      getExcel(this.bankholder_id, this.start_date, this.end_date);
    },
    PDFReport() {
      getPDF(this.bankholder_id, this.start_date, this.end_date);
    },
  },
  created() {
    this.getTransactionData();
    this.getUtility();
  },
};
</script>

<style lang="scss">
.bank-statement-container {
  .search-area {
    margin-bottom: 16px;
    button {
      margin-left: 10px;
    }
  }

  .vender-status {
    .vender-status-main {
      margin-bottom: 8px;
      .el-tag {
        font-size: 16px;
        padding: 0 16px;
        height: 36px;
        line-height: 34px;
      }
    }
    .vender-status-error {
      color: #f56c6c;
    }
  }

  code {
    color: #408fff;
    background-color: #e6effb;
    margin: 0 4px;
    display: inline-block;
    padding: 1px 5px;
    font-size: 14px;
    border-radius: 3px;
    height: 18px;
    line-height: 18px;
  }

  pre {
    white-space: pre-line;
    line-height: 30px;
  }

  .pagination-statement {
    margin-top: 10px;
  }
}
</style>
